import { STAFF_ROLES } from "@shared/core/types";
import type { WebModule } from "../../core/modules";
import { CandidateLinksPage } from "./routes/candidate-links";
import { AllLinksPage } from "./routes/all-links";
import { PublicLinkPage } from "./routes/public-link";

const xAvocats: WebModule = {
  name: "x-avocats",
  routes: [
    { path: "/candidats/:id/partages", element: <CandidateLinksPage />, roles: STAFF_ROLES },
    { path: "/partages", element: <AllLinksPage />, roles: STAFF_ROLES },
  ],
  // Page du destinataire : hors connexion, hors shell.
  publicRoutes: [{ path: "/lien/:token", element: <PublicLinkPage /> }],
  nav: [
    {
      title: "Avocats",
      order: 30,
      roles: STAFF_ROLES,
      items: [{ to: "/partages", label: "Liens sécurisés", icon: "shield", end: true }],
    },
  ],
};

export default xAvocats;
